import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { CreateNewChatButton } from '@modules/oracle/components/CreateNewChatButton';
import { WisdomChatArchiveModalContent } from '@modules/oracle/components/WisdomChatArchiveModalContent';
import { WisdomChatDetails } from '@modules/oracle/components/WisdomChatDetails';
import { WisdomChatShareModalContent } from '@modules/oracle/components/WisdomChatShareModalContent';
import { useHasChatEditAccess } from '@modules/oracle/hooks';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { trackWisdomEvents } from '@modules/oracle/utils';
import { ArchiveRounded, ShareRounded } from '@mui/icons-material';
import AddRounded from '@mui/icons-material/AddRounded';
import { Button, Divider, Stack, Tooltip } from '@mui/material';

export const WisdomSavedChatToolbar = () => {
  const { openModal } = useMuiModalContext();
  const chat = useOracleSearchStore(({ data }) => data.chat);
  const hasEditAccess = useHasChatEditAccess();

  const openChatShareModal = () => {
    openModal({
      contentComponent: () => (
        <WisdomChatShareModalContent chatName={chat?.title} />
      ),
      modalProps: {
        maxWidth: 'sm',
        fullWidth: true,
        PaperProps: {
          elevation: 3,
        },
      },
    });
    trackWisdomEvents({
      eventName: 'Wisdom - Chat Share Button Clicked',
      chatName: chat?.title,
      from: 'Header',
    });
  };

  const openChatArchiveModal = () => {
    if (!chat) {
      return;
    }

    openModal({
      contentComponent: () => <WisdomChatArchiveModalContent chat={chat} />,
      modalProps: {
        maxWidth: 'sm',
        fullWidth: true,
        PaperProps: {
          elevation: 3,
        },
      },
    });

    trackWisdomEvents({
      eventName: 'Wisdom - Chat Archive Button Clicked',
      chatName: chat?.title,
      from: 'Header',
    });
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        position: 'sticky',
        height: '3.5rem',
        zIndex: 10,
        px: 4,
        pt: 1,
        pb: 2,
        mb: 1,
        top: 0,
        boxSizing: 'content-box',
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <WisdomChatDetails shouldShowRenameButton={hasEditAccess} />
      <Stack direction="row" alignContent="center" spacing={1.5}>
        {hasEditAccess ? (
          <>
            <Button
              size="small"
              color="primary"
              startIcon={<ShareRounded />}
              onClick={openChatShareModal}
            >
              Share
            </Button>
            <Button
              size="small"
              color="primary"
              startIcon={<ArchiveRounded />}
              onClick={openChatArchiveModal}
            >
              Archive
            </Button>
            <Divider orientation="vertical" />
          </>
        ) : null}
        <Tooltip title="Create New Wisdom Chat" arrow placement="bottom">
          <CreateNewChatButton
            buttonText="New"
            buttonProps={{
              size: 'small',
              variant: 'outlined',
              color: 'primary',
              startIcon: <AddRounded />,
            }}
          />
        </Tooltip>
      </Stack>
    </Stack>
  );
};
